import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a65beb5a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a65beb5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65beb5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a65beb5a')) {
      api.createRecord('a65beb5a', component.options)
    } else {
      api.reload('a65beb5a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a65beb5a&scoped=true&", function () {
      api.rerender('a65beb5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2P4lnR0dAT7V1/JS/teamMember.vue"
export default component.exports